import React from 'react';
import LogoDRAI from 'presentation/assets/images/logo_drai.svg';
import LogoIngenia from 'presentation/assets/images/logo_ingenia.svg';

const Footer = () => (
  <div className='bg-white-300 pt-44 pb-24'>
    <div className='max-w-screen-xl w-full mx-auto px-6 sm:px-8 lg:px-16 grid grid-rows-6 sm:grid-rows-1 grid-flow-row sm:grid-flow-col grid-cols-3 sm:grid-cols-12 gap-4'>
      <div className='row-span-2 sm:col-span-2 col-start-1 col-end-2 sm:col-end-3 flex flex-col items-start '>
        <ul className='text-black-500'>
          <li className=''>
            <img
              className='h-14 w-auto'
              src={LogoDRAI}
              alt='Buscar grabaciones'
            />
          </li>
          <li className=''>
            <img
              className='h-14 w-auto'
              src={LogoIngenia}
              alt='Buscar grabaciones'
            />
          </li>
        </ul>
      </div>
      <div className=' row-span-2 sm:col-span-2 sm:col-start-4 sm:col-end-6 flex flex-col'>
        <ul className='text-black-500 '>
          <li className='my-2 hover:text-orange-500 cursor-pointer transition-all'>
            Virtual Ingeniería{' '}
          </li>
          <li className='my-2 hover:text-orange-500 cursor-pointer transition-all'>
            Ingenia{' '}
          </li>
          <li className='my-2 hover:text-orange-500 cursor-pointer transition-all'>
            Misión TICs{' '}
          </li>
        </ul>
      </div>
      <div className='row-span-2 sm:col-span-4 sm:col-start-8 sm:col-end-13 flex flex-col'>
        <p className='mb-4'>
          <strong className='font-medium'>
            Grabaciones de Cursos Ingenia y Facultad de Ingeniería UdeA
          </strong>{' '}
          .
        </p>
        <p className='text-gray-400'>
          ©{new Date().getFullYear()} - Ingenia UdeA
        </p>
      </div>
    </div>
  </div>
);

export default Footer;
